
export const text = `

You gave part of yourself to Zampanio.

Zampanio gave itself to Lavinraca.

Lavinraca is inside your mind.



You gave part of yourself to Lavinraca.

Lavinraca gave itself to Zampanio.

Zampanio is inside your mind.


You can be careful all you want with what you let inside your mind. But what you let in connects to other things.

`